import { ProspectsService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { handleError } from '@/utils/error'

export const useRemoveProspect = () => {
  const queryClient = useQueryClient()
  const toast = useToast()

  const removeMutation = useMutation(
    (id: number) => ProspectsService.deleteProspect({ id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['prospects'])
        toast.success('Prospect removed successfully')
      },
      onError: (error) => {
        handleError(error, 'Failed to remove prospect')
      },
    },
  )

  return {
    removeProspect: removeMutation.mutateAsync,
    isRemovingProspect: removeMutation.isLoading,
  }
}
